import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { legalDisclosure, navLinks } from '../data/site';
export function Footer() {
  return <footer className="border-t border-line bg-paper" data-id="element-36" data-mp="3gh3sii3dgcgq">
      <div className="mx-auto max-w-[1240px] px-6 py-16 md:px-10 md:py-20" data-id="element-37" data-mp="32p5mig4yiwos">
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-12 md:gap-12" data-id="element-38" data-mp="36oo8lf8ildt7">
          <div className="sm:col-span-2 md:col-span-6" data-id="element-39" data-mp="3ufa4y995p9nd">
            <Logo size="lg" data-id="element-40" data-mp="3uftn9r2py01x" />
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-mist" data-id="element-41" data-mp="38qvoyiyxrr6">
              An AI-native law firm combining technology with lawyer oversight.
            </p>
          </div>

          <nav aria-label="Footer" className="md:col-span-3" data-id="element-42" data-mp="3lgonyijc22op">
            <p className="text-[12px] uppercase tracking-[0.16em] text-mist" data-id="element-43" data-mp="3qc445h4tcaoa">
              Navigate
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-44" data-mp="29xvqyd5xndpb">
              {navLinks.map(link => <li key={link.to} data-id="element-45" data-mp="2ezuubn1oaam9">
                  <Link to={link.to} className="text-[15px] text-graphite transition-colors hover:text-ink" data-id="element-46" data-mp="3l9k5rctv1nda">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="md:col-span-3" data-id="element-47" data-mp="3v5dhitzr9cu0">
            <p className="text-[12px] uppercase tracking-[0.16em] text-mist" data-id="element-48" data-mp="3q7lmvs7q7cm4">
              Get in touch
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-49" data-mp="81fqhygiyw59">
              <li data-id="element-50" data-mp="34741locg5y7">
                <a href="mailto:hello@nexlegal.ca" className="text-[15px] text-graphite transition-colors hover:text-ink" data-id="element-51" data-mp="34pafb4q00ju">
                  hello@nexlegal.ca
                </a>
              </li>
              <li data-id="element-52" data-mp="cvtn246xb9bi">
                <Link to="/contact" className="text-[15px] text-graphite transition-colors hover:text-ink" data-id="element-53" data-mp="qthyklf3p43w">
                  Contact form
                </Link>
              </li>
              <li className="text-[15px] text-mist" data-id="element-54" data-mp="tvw8wk94jlhk">nexlegal.ca</li>
            </ul>
          </div>
        </div>

        <p className="mt-14 max-w-3xl border-t border-line pt-6 text-[13px] leading-relaxed text-mist" data-id="element-55" data-mp="yuzce09ghjnf">
          {legalDisclosure}
        </p>

        <div className="mt-8 flex flex-col gap-3 border-t border-line pt-6 text-[13px] text-mist md:flex-row md:items-center md:justify-between" data-id="element-56" data-mp="13rg2v144oa3o">
          <p data-id="element-57" data-mp="1ckkqaw8ef8ol">© {new Date().getFullYear()} NexLegal. All rights reserved.</p>
          <p data-id="element-58" data-mp="1hk5xtv1mwpcx">Currently focused on Ontario and Quebec.</p>
        </div>
      </div>
    </footer>;
}